/**
 * Delay before the next automatic GET /auth/providers attempt.
 *
 * First failure waits 2s, then 4s, 8s, 16s, then stays at 30s. A control plane
 * that systemd brings back in RestartSec=3 is picked up on the first retry.
 * A tight loop (retry on every render, or every 100ms) would hammer a down
 * API, fill the proxy log, and still show the same error.
 */
export function providersRetryDelayMs(failureCount: number): number {
  const n = Math.max(1, failureCount);
  return Math.min(2_000 * 2 ** (n - 1), 30_000);
}
